import { setContext } from '@apollo/client/link/context';

type StoredAuthToken = {
    token?: string;
};

export const authLink = setContext((_, { headers }) => {
    let token: StoredAuthToken | undefined = undefined;

    if (typeof window !== 'undefined') {
        const tokenJson = window.localStorage.getItem('auth-token');

        if (tokenJson) {
            token = JSON.parse(tokenJson) as StoredAuthToken;
        }
    }

    return {
        headers: {
            ...headers,
            Authorization: token?.token ? `Bearer ${token.token}` : ''
        }
    };
});
